var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLegalDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 25V17C1 9.45753 1 5.68629 3.34315 3.34315C5.68629 1 9.45753 1 17 1H21C28.5425 1 32.3137 1 34.6569 3.34315C37 5.68629 37 9.45753 37 17V25C37 32.5425 37 36.3137 34.6569 38.6569C32.3137 41 28.5425 41 21 41H17C9.45753 41 5.68629 41 3.34315 38.6569C1 36.3137 1 32.5425 1 25Z",
    stroke: "#5784F7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6667 18.3333C19.7766 20.4432 22.5556 22.5873 22.5556 22.5873L26.3651 18.7778C26.3651 18.7778 24.221 15.9988 22.1111 13.8889C20.0012 11.779 17.2222 9.63492 17.2222 9.63492L13.4127 13.4444C13.4127 13.4444 15.5568 16.2234 17.6667 18.3333ZM17.6667 18.3333L11 25M27 18.1429L21.9206 23.2222M17.8571 9L12.7778 14.0794",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M11 33H27",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegalDocument);
export default __webpack_public_path__ + "static/media/IconLegalDocument.a2b9188678cb4b626437dc035f886a9f.svg";
export { ForwardRef as ReactComponent };